import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const tabs = [
  { id: "public", label: "Public Profile" },
  { id: "billing", label: "Billings & Plans" },
  { id: "grocery", label: "My Grocery Lists" },
];

function Settings({ onOpenAuth, onOpenMenu }) {
  const [activeTab, setActiveTab] = useState("public");
  const [groceryView, setGroceryView] = useState("lists"); // lists | create | detail

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto flex max-w-6xl gap-10 px-4 py-10 md:px-6 min-h-[calc(100vh-120px)]">
        <aside className="w-56 rounded-2xl border border-slate-200 bg-white px-5 py-6 text-xs">
          <h2 className="mb-6 text-[18px] font-semibold text-slate-900">
            Settings
          </h2>

          <nav className="space-y-2 text-[13px]">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => {
                  setActiveTab(tab.id);
                  if (tab.id === "grocery") {
                    setGroceryView("lists");
                  }
                }}
                className={`flex w-full items-center rounded-full px-4 py-2 text-left transition ${
                  activeTab === tab.id
                    ? "bg-slate-900 text-white"
                    : "bg-transparent text-slate-600 hover:bg-slate-50"
                }`}
              >
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </aside>

        <section className="flex-1 space-y-6">
          {activeTab === "public" && <PublicProfilePanel />}
          {activeTab === "billing" && <BillingPlansPanel />}
          {activeTab === "grocery" && (
            <GrocerySettingsPanel
              view={groceryView}
              onChangeView={setGroceryView}
            />
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}

function PanelShell({ title, action, children }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white px-7 py-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
        {action}
      </div>
      {children}
    </div>
  );
}

function PublicProfilePanel() {
  return (
    <PanelShell
      title="Public Profile"
      action={
        <button className="rounded-full bg-indigo-600 px-5 py-2 text-xs font-semibold text-white">
          Change Password
        </button>
      }
    >
      <div className="flex flex-col gap-10 md:flex-row md:items-start">
        <div className="flex flex-col items-center gap-3">
          <div className="flex h-24 w-24 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold text-slate-500">
            IMG
          </div>
          <div className="space-y-2 text-xs">
            <button className="block rounded-md border border-slate-300 bg-slate-900 px-4 py-1.5 text-[11px] font-semibold text-white">
              Change picture
            </button>
            <button className="block rounded-md border border-slate-300 px-4 py-1.5 text-[11px] font-semibold text-slate-800">
              Delete picture
            </button>
          </div>
        </div>

        <div className="grid flex-1 gap-4">
          <div className="space-y-1 text-xs">
            <label className="block text-[12px] font-medium text-slate-600">
              Full Name
            </label>
            <input
              className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-[13px] text-slate-800 outline-none focus:border-indigo-500"
              placeholder="Full Name"
            />
          </div>
          <div className="space-y-1 text-xs">
            <label className="block text-[12px] font-medium text-slate-600">
              Email
            </label>
            <input
              className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-[13px] text-slate-800 outline-none focus:border-indigo-500"
              placeholder="Email"
            />
          </div>
          <div className="space-y-1 text-xs md:col-span-2">
            <label className="block text-[12px] font-medium text-slate-600">
              Full Address
            </label>
            <input
              className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-[13px] text-slate-800 outline-none focus:border-indigo-500"
              placeholder="Full Address"
            />
          </div>
        </div>
      </div>

      <div className="mt-8">
        <button className="rounded-md bg-indigo-600 px-8 py-2 text-xs font-semibold text-white">
          Save
        </button>
      </div>
    </PanelShell>
  );
}

function BillingPlansPanel() {
  return (
    <PanelShell
      title="Billings & Plans"
      action={
      <></>
      }
    >
      <div className="space-y-6 text-xs text-slate-600">
        <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-900 text-[11px] font-semibold text-white">
              F
            </div>
            <div>
              <div className="flex items-center gap-3">
              <p className="text-[13px] font-semibold text-slate-900">
                Standard Plan
              </p>
              <span className="rounded-full bg-emerald-50 px-3 py-1 text-[11px] font-semibold text-emerald-600">
            Active
          </span>
          </div>
              <p className="mt-0.5 text-[11px] text-slate-600">
                Billing Monthly | Next Payment on 02/03/2026 for £10.75
              </p>
            </div>
          </div>
          <button className="rounded-md bg-slate-900 px-5 py-2 text-xs font-semibold text-white">
          Change Plan
        </button>
        </div>

        <div>
          <p className="mb-3 text-[12px] font-semibold text-slate-700">
            Transaction history
          </p>
          <div className="overflow-hidden rounded-xl border border-slate-200 text-[12px]">
            <div className="grid grid-cols-5 bg-slate-50 px-4 py-2 font-semibold text-slate-600">
              <span>Reference</span>
              <span>Product</span>
              <span>Status</span>
              <span>Date</span>
              <span className="text-right">Amount</span>
            </div>
            {["#95687"].map((id) => (
              <div
                key={id}
                className="grid grid-cols-5 items-center border-t border-slate-100 px-4 py-2 text-slate-600"
              >
                <span>{id}</span>
                <span>Standard</span>
                <span className="text-emerald-500">Paid</span>
                <span>02/02/2026</span>
                <span className="text-right">£29.99</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PanelShell>
  );
}

function GrocerySettingsPanel({ view, onChangeView }) {
  if (view === "detail") {
    return (
      <GroceryDetail onBack={() => onChangeView("lists")} />
    );
  }

  if (view === "create") {
    return (
      <GroceryListsWithCreate
        onCancel={() => onChangeView("lists")}
        onCreate={() => onChangeView("detail")}
      />
    );
  }

  return (
    <GroceryListsOverview
      onOpenCreate={() => onChangeView("create")}
      onOpenDetail={() => onChangeView("detail")}
    />
  );
}

function GroceryListsOverview({ onOpenCreate, onOpenDetail }) {
  return (
    <PanelShell
      title="My Grocery Lists"
      action={
        <button
          className="rounded-md bg-slate-900 px-5 py-2 text-xs font-semibold text-white"
          onClick={onOpenCreate}
        >
          + Create List
        </button>
      }
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {["List Title 1", "List Title 2", "List Title 3"].map((name, index) => (
          <button
            key={name}
            type="button"
            onClick={onOpenDetail}
            className="flex flex-col items-stretch rounded-2xl border border-slate-200 bg-slate-50 p-3 text-left hover:border-indigo-500"
          >
            <div className="mb-3 h-24 rounded-xl bg-slate-100" />
            <p className="text-xs font-semibold text-slate-800">
              {name}
            </p>
            <div className="flex items-center justify-between">
            <p className="mt-1 text-[11px] text-slate-500">
            Budget- £50
            </p>
            <p className="mt-1 text-[11px] text-slate-500">
           Products-4
            </p>
            </div>
          </button>
        ))}
      </div>
    </PanelShell>
  );
}

function GroceryListsWithCreate({ onCancel, onCreate }) {
  return (
    <PanelShell
      title="My Grocery Lists"
      action={
        <button className="rounded-md bg-slate-900 px-5 py-2 text-xs font-semibold text-white">
          + Create List
        </button>
      }
    >
      <div className="relative">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {["List title 1", "List title 2"].map((name) => (
            <div
              key={name}
              className="rounded-2xl border border-slate-200 bg-slate-50 p-4"
            >
              <div className="mb-3 flex items-center justify-between rounded-xl bg-slate-100 px-4 py-6">
                <div className="grid grid-cols-2 gap-2">
                  {[0, 1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className="h-10 w-10 rounded-md bg-slate-200"
                    />
                  ))}
                </div>
              </div>
              <p className="text-xs font-semibold text-slate-800">{name}</p>
              <p className="mt-1 text-[11px] text-slate-500">Budget: £50</p>
              <p className="mt-1 text-[11px] text-slate-500">Products: 4</p>
            </div>
          ))}
        </div>

        <div className="absolute inset-0 flex items-center justify-center bg-black/5">
          <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white px-6 py-5 text-xs shadow-lg">
            <div className="mb-4 flex items-center justify-between">
              <p className="text-[14px] font-semibold text-slate-900">
                Create List
              </p>
              <button
                type="button"
                onClick={onCancel}
                className="text-slate-500 hover:text-slate-800"
              >
                ✕
              </button>
            </div>

            <div className="space-y-3">
              <div className="space-y-1">
                <input
                  className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-[13px] text-slate-800 outline-none focus:border-indigo-500"
                  placeholder="Title"
                />
              </div>
              <div className="space-y-1">
                <input
                  className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-[13px] text-slate-800 outline-none focus:border-indigo-500"
                  placeholder="Budget"
                />
              </div>

              <div className="mt-4 flex items-center justify-center gap-3">
               
                <button
                  type="button"
                  onClick={onCreate}
                  className="rounded-md bg-slate-900 px-8 py-2 text-sm font-semibold text-white"
                >
                  Save →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelShell>
  );
}

function GroceryDetail({ onBack }) {
  return (
    <PanelShell
      title="Grocery Detail"
      action={
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onBack}
            className="rounded-full border border-slate-200 px-4 py-1.5 text-xs font-medium text-slate-600"
          >
            Back to lists
          </button>
          <button className="rounded-md border border-slate-200 px-4 py-1.5 text-xs font-medium text-white bg-black">
            Rename
          </button>
          <button className="rounded-md bg-[#FF383C] px-4 py-1.5 text-xs font-semibold text-white">
            Delete
          </button>
        </div>
      }
    >
      <div className="mb-4 text-xs text-slate-600">
        <p className="text-[13px] font-semibold text-slate-800">List 01</p>
        <p className="mt-0.5 text-[11px] text-slate-500">
          3 items · Estimated £9.49
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((idx) => (
          <div
            key={idx}
            className="flex flex-col rounded-2xl border border-slate-200 bg-slate-50 p-3"
          >
            <div className="mb-3 h-24 rounded-xl bg-slate-100" />
            <p className="text-xs font-semibold text-slate-800">
              Easy Wing Turbo
            </p>
            <p className="mt-1 text-[11px] text-slate-500">
              3 items · from Tesco
            </p>
            <div className="mt-3 flex items-center justify-between text-[11px]">
              <span className="font-semibold text-slate-800">£3.49</span>
              <button className="rounded-full bg-indigo-600 px-3 py-1 text-[11px] font-semibold text-white">
                View
              </button>
            </div>
          </div>
        ))}
      </div>
    </PanelShell>
  );
}

export default Settings;

